var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-nowrap mr-1 mr-lg-2 mr-md-2 px-1 text-center",class:{'ml-lg-2':!_vm.left, 'ml-md-2':!_vm.left}},[_c('i',{class:_vm.icn}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }